/*
export const someAction = (state) => {}
 */
import { api } from 'src/plugins/axios'
import { pickAddress } from 'src/utils/addressVerification'
import { notify } from 'src/plugins/notify'
import { createQueryString, serializeObject } from 'src/utils'
import Vue from 'vue'
import { debounce } from 'quasar'
import router from 'src/router'
const moment = require('moment')
const xlsx = require('xlsx')

export default {
    one,
    fetchClasses,
    generateCertificates,
    exportExcel,
    fetchInstructors,
    fetchAutoComplete,
    autocompleteInstructors,
    upsertCalendarClass,
    removeSession,
    destroyClass,
    submitClassForApproval,
    loadAffiliates,
    loadAffiliatesForSearch,
    loadInstructorsForAffiliate,
    loadCoursesForAffiliate,
    setSessionStudentAddress,
    loadAllInstructors,
    expandClass,
    processSchedule,
    finalizeUpload,
    rereportStudents,
    checkoutClass,
    instructorAutocomplete,
    affiliateAutocomplete,
    reprocessCertificates,
    emailClassMeetingLink,
    deleteClass,
}

async function emailClassMeetingLink({}, payload){
    try{
        let response = await api.post('classes/emailMeetingLink', payload)
        return response
    }    
    catch(err){
        notify.create({
            message: "Error Sharing Link.",
            type: "negative"
        })
        return { error: true }
    }
}

async function one({ commit, dispatch, state, rootState, rootGetters }, payload) {
    let vm = this._vm
    let id = payload.id
    let mode = payload.mode

    vm.$q.loading.show({
        message: "Loading Class"
    })
    
    try{
        state.rereporting = false
        if (mode === 'add' || !id) {
            let date = payload.start ?
              moment(payload.start).format("MM/DD/YYYY")
              : moment(new Date()).add(30, 'days').format("MM/DD/YYYY")

            commit('updateSessionInformation', {
                start: date,
                end: '',
                newClass: true,
                minStart: date,
            })
            await loadAffiliates({ commit, state })
            commit('updateSelectedSession', 1)
            vm.$q.loading.hide()
            commit('updateAddEditClassOpenState', true)
            commit('updateModalLoading', false)
        }
        else {
            await api.get('/calendar/' + id)
                .then(async result => {
                    let sessionInformation = result.data.payload
                    
                    if(!result.data.success){                        
                        commit('updateModalLoading', false)
                        vm.$q.loading.hide()
                        return notify.create({message:result.data.message,type:"negative"})
                    }

                    // Clear rejection notes
                    commit('approvals/updateRejectionNotes',null, {root:true})
                    
                    sessionInformation.sessions = _.map(sessionInformation.sessions, session => {
                        let dateFormat   = '',
                            invalidStart = session.start == 'Invalid date',
                            invalidEnd   = session.end == 'Invalid date',
                            targetStart  = invalidStart ? (!invalidEnd   ? session.end   : moment(new Date()).subtract(5,'hours').format(dateFormat)) : session.start,
                            targetEnd    = invalidEnd   ? (!invalidStart ? session.start : moment(new Date()).subtract(5,'hours').format(dateFormat)) : session.end
                        
                        session.invalidStart = invalidStart
                        session.invalidEnd   = invalidEnd

                        // Start
                        session.startDate   = moment(targetStart,"YYYY-MM-DD HH:mm").utc().format('MM/DD/YYYY')
                        session.startHour   = moment(targetStart,"YYYY-MM-DD HH:mm").utc().format('hh')
                        session.startMin    = moment(targetStart,"YYYY-MM-DD HH:mm").utc().format('mm')
                        session.startPeriod = moment(targetStart,"YYYY-MM-DD HH:mm").utc().format('A')

                        // End
                        session.endDate   = moment(targetEnd,"YYYY-MM-DD HH:mm").utc().format('MM/DD/YYYY')
                        session.endHour   = moment(targetEnd,"YYYY-MM-DD HH:mm").utc().format('hh')
                        session.endMin    = moment(targetEnd,"YYYY-MM-DD HH:mm").utc().format('mm')
                        session.endPeriod = moment(targetEnd,"YYYY-MM-DD HH:mm").utc().format('A')                        

                        session.students = _.map(session.students, student => {
                            student.dlStateName = student.dlState ? _.find(rootGetters.stateOptions, state => state.value === student.dlState).label : null
                            student.stateName   = student.stateId ? _.find(rootGetters.stateOptions, state => state.value === student.stateId).label : null
                            return student
                        })

                        return session
                    })

                    // Addresses the server says are verified show as Verified
                    // without asking Google again.
                    dispatch('addressVerification/seed', {
                        addresses: _.flatMap(sessionInformation.sessions, session =>
                            session.students.filter(student => student.addressVerified).map(pickAddress))
                    }, { root: true })

                    commit('updateSessionInformation', sessionInformation)
                    commit('updateInitialSessionForComparison', sessionInformation)

                    await loadAffiliates({ commit, state }, sessionInformation.selectedAffiliate)
                    await loadCoursesForAffiliate({ commit, state }, {affiliateId: sessionInformation.selectedAffiliate, classId: id })
                    await loadInstructorsForAffiliate({ commit, state }, sessionInformation.selectedAffiliate)
                    
                    state.sessionInformation.rereportStudents = {}
                    
                    if (payload.sessionId) {
                        commit('updateSelectedSession', payload.sessionId)
                    } else {
                        commit('updateSelectedSession', id)
                    }
                    commit('updateModalMode', mode)
                    commit('updateAddEditClassOpenState', true)
                    commit('updateModalMode', mode)

                    vm.$root.$emit('updateClassesModalEditState')
                    vm.$q.loading.hide()
                    commit('updateModalLoading', false)
                    state.issuing = false
                })
        }
    }
    catch(err){
        console.error(err)
        if(vm) vm.$q.loading.hide()
        notify.create({
            message: "Error loading class.",
            type: "negative"
        })
    }
}



async function reprocessCertificates({commit, state},{students,session}){
    let originalStudents = state.sessionInformation.sessions[session].students
    let studentsToProcess = _.filter(originalStudents, (student, i) => {
        return students.indexOf(i) > -1
    })
    try{
        let { data } = await api.post('classes/reprocessCertificates', { students:studentsToProcess, classId: state.sessionInformation.classId })
        let { success, message } = data
        notify.respond(data)
    }
    catch(err){
        console.log(err)
    }
}

async function fetchClasses({ commit, state }, { pagination, filter, columns, exportOptions }) {
    commit('isLoading')
    try {
        let query = createQueryString({ pagination, filter, columns, exportOptions })

        let fieldQuery
        
        let finalSearchFields = _.pickBy(state.searchFields, v => {
            return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
        })
        
        console.log(state.includeExpiredClasses)
        if (!_.isEmpty(finalSearchFields) || state.includeExpiredClasses) {
            fieldQuery = serializeObject({ searchType: state.searchType, searchFields: { ...finalSearchFields }, includeExpiredClasses: state.includeExpiredClasses })
            console.log(fieldQuery)
        }
        
        let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')
        const { data: response } = await api.get('/classes/fetchClasses' + finalQuery)
        const { success, payload } = response
        if (!success) throw response
        commit('setClasses', payload.classes)
        commit('doneLoading')
        return response
    }
    catch (response) {
        commit('doneLoading')
        return response
    }
}

async function loadAllInstructors({commit, state}){
    
    try{
        let { data } = await api.get('/classes/getInstructors')
        let { success, payload } = data
        state.instructors = payload
    }
    catch(err){
        state.instructors = []
    }
}

async function rereportStudents ({commit, state, rootState}, {students, vm}) {
    let currentCourse = _.find(state.sessionInformation.courses, { value: state.sessionInformation.selectedCourse })
    //let currentAffiliate = state.sessionInformation.selectedAffiliateObject
    rootState.orders.loadOrderTypes = false
    
    // If payments are enabled, we need to process that.
    if(!currentCourse.DISABLE_PAYMENTS){
        rootState.orders.pendingPayment.canAdd = false
        let itemIndex = 0
        let orderTypeId = 77
        rootState.orders.processPaymentModalOpen = true
        rootState.orders.orderTypes = [
            {
                "ORDER_TYPE_ID": orderTypeId,
                "ORDER_TYPE_NAME": "Rereport",
                "USER_ID": 2, // no idea why this is 2, but it was here before
                "PRICE": 10,
                "MIN_AMOUNT": null,
                "MAX_AMOUNT": null,
                "LK_USER_TYPE_ID": null,
                "DELETABLE_IND": 0,
                "SHIPPING_METHODS": [],
            }
        ]
        commit('orders/addPendingOrderItem', {}, { root: true })
        commit('orders/updateItemFromType', {
            itemIndex: itemIndex,
            quantity: students.length,
            orderType: orderTypeId // orderType.ORDER_ID
        }, { root: true })
        //commit('orders/updateItemShippingMethodOptions', { itemIndex, orderTypeId }, { root: true })

        rootState.orders.afterProcessCallback = async function(orderData){
            await rereportStudents(orderData)
            if(orderData.data.success){
                vm.$root.$emit('refreshGrid:classListGrid')
                vm.$root.$emit('schedulerRefresh')
            }
        }
        
    }
    else{
        rereportStudents({data:{success:true, data:{ ORDER_ID:null }}})
    }

    async function rereportStudents(orderData){
        state.rereporting = true    
        commit('updateModalLoading', true)
        if(!orderData.data.success){
            commit('orders/updatePaymentCallback', async function(orderData){
                await rereportStudents(orderData)
                if(orderData.data.success){
                    vm.$root.$emit('refreshGrid:classListGrid')
                    vm.$root.$emit('schedulerRefresh')
                }
            }, {root:true})
            return
        }
        if(orderData.data.success){
            let CLASS_ID = state.sessionInformation.classId
            let ORDER_ID = orderData.data.data.ORDER_ID
            let COURSE_ID = state.sessionInformation.selectedCourse
            let students = state.sessionInformation.rereportStudents
            let allStudents = []
            _.map(state.sessionInformation.sessions, session => {
                allStudents.push(...session.students)
            })
            students = _.map(students, s =>{
                return _.find(allStudents, { studentId: s.studentId })
            })

            students = _.uniqBy(students,'studentId')
            
            let { data } = await api.post('/classes/rereport',  { CLASS_ID, ORDER_ID, COURSE_ID, students })
            let { message, success } = data
            notify.respond(data)
            if(success){
                commit('updateAddEditClassOpenState', false)
            }
        }    
        state.rereporting = false        
        commit('updateModalLoading', false)        
    }
}

async function instructorAutocomplete({commit, state}, search) {
    try{
        let { data } = await api.post('/classes/getInstructors', {s: search})
        let { success, payload } = data
        return payload
    }
    catch(err){
        console.log(err)
        return []
    }
}

async function affiliateAutocomplete({commit, state}, { search, scope = null }) {
    try{
        let { data } = await api.post('/affiliate/classAffiliateDropdown', { s: search, scope })
        let { success, payload } = data
        return payload
    }
    catch(err){
        console.log(err)
        return []
    }
}

async function processSchedule({commit, state }, file){
    let fr = new FileReader()
    state.processingSchedule = true
    fr.onload = async e => {
        try{
            let name = file.name
            var filename = file.name;

            // pre-process data
            var binary = "";
            var bytes = new Uint8Array(e.target.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }

            // call 'xlsx' to read the file
            var workbook = xlsx.read(binary, {type: 'binary', cellDates:true, cellStyles:false})
            let sheetNames = workbook.SheetNames

            var rows = []
            
            sheetNames.forEach(function(y) {
                var worksheet = workbook.Sheets[y]
                var headers = {}
                for(let z in worksheet) {
                    if(z[0] === '!' || z[0] === 'O') continue;
                    //parse out the column, row, and value
                    var col = z.substring(0,1)
                    var row = parseInt(z.substring(1))
                    var value = worksheet[z].v

                    //store header names
                    if(row == 1) {
                        headers[col] = value
                        continue
                    }

                    if(!rows[row]) rows[row]= {}
                    if(headers[col] != 'Accord') rows[row][headers[col]] = value

                }
                //drop those first two rows which are empty
                rows = _.toArray(_.pickBy(rows,_.identity))
            })

            let { data } = await api.post('/classes/processSchedule/',{ rows: rows })
            let { success, message, payload } = data
            
            state.processedRows = payload
            
            setTimeout(function(){
                state.processingSchedule = false
                if(success){
                    commit('setProcessedRows', payload)
                    state.scheduleProcessed = true
                }
                else{
                    notify.create({message, type: "negative"})
                }
            },300)
        }
        catch(err){
            state.processingSchedule = false
            notify.create({
                message: "Error processing schedules. Try again.",
                type: "negative"
            })
        }
    }
    fr.readAsArrayBuffer(file)
}

async function finalizeUpload({ state }, { vm }){
    state.processingSchedule = true

    let { data } = await api.post('/classes/finalizeProcessSchedule', {rows: state.processedRows})
    let { success, message, payload } = data

    state.processingSchedule = false    
    if(success){
        state.scheduleUploadOpen = false
        notify.create({message, type: "positive"})
        
        // Autoselect the affiliates in the list
        state.processedRows.forEach(row => {
            let classAffiliate = _.find(state.filteredAffiliates, { AFFILIATE_ID : row.AFFILIATE.AFFILIATE_ID })    
            if(classAffiliate){
                classAffiliate.open = true
                classAffiliate.selected = true
                _.map(classAffiliate.INSTRUCTORS, i => i.selected = true)
            }
        })
        vm.$root.$emit('refreshGrid:classListGrid')
        vm.$root.$emit('schedulerRefresh')
    }
    else{
        notify.create({message, type: "negative"})
    }
        
}

async function exportExcel() {
    commit('isLoading')
    const exportExcel = true
    try {
        const query = createQueryString({ pagination, filter, columns, exportExcel })
        const { data: response } = await api.get('/classes/fetchClasses' + query)

        const { success, payload } = response
        commit('doneLoading')
        if (!success) throw response

        return response
    } catch (response) {
        return response
    }
}

async function expandClass({commit, state}, {row,expanded}){
    if(expanded){
        row.loading = true
        let classId = row.CLASS_ID
        let { data } = await api.get(`/classes/getSessions/?id=${classId}`)
        let currentClass = state.classList.filter(x => x.CLASS_ID == classId)
        let currentClassIndex = _.findIndex(state.classList,x => x.CLASS_ID == classId)
        
        if(currentClass && data && data.data.SESSIONS){
            console.log(data.data.SESSIONS)
            state.classList[currentClassIndex].SESSIONS = data.data.SESSIONS
        }
        setTimeout(function(){
            row.loading = false
        },250)
    }
}
async function fetchInstructors({ commit, rootState }, {alreadySelected, vm}) {
    let result = await api.get('/calendar/affiliates')
    // Success
    if (result.data.success) {
        rootState.auth.user.APPROVED_INSTRUCTOR = true
        commit('setSchedulerAffiliates', { result, alreadySelected })
        vm.$root.$emit('schedulerRefresh')
    }
    else{
        rootState.auth.user.APPROVED_INSTRUCTOR = false
    }
    
    notify.respond(result.data)
}

async function fetchAutoComplete({ commit, dispatch, state }, { s }) {
    try {
        const { data: response } = await api.post('/user/autocomplete', { s })
        commit('setAutoCompleteList', { users: response.payload })
    } catch (err) {

    }
}

async function autocompleteInstructors({ commit, state }) {
    const result = await api.get('/instructor/autocomplete')
    return result
}

async function upsertCalendarClass({ commit, state, rootGetters }) {
    let endpoint = (state.sessionInformation.classId) ? 'update' : 'add'
    
    // Select the affiliate on the calendar
    let classAffiliate = _.find(state.filteredAffiliates, {AFFILIATE_ID : state.sessionInformation.selectedAffiliate})    
    if(classAffiliate){
        classAffiliate.open = true
        classAffiliate.selected = true
        _.map(classAffiliate.INSTRUCTORS, i => i.selected = true)
    }

    // console.log(state.sessionInformation,state.initialSessionForComparison)
    // console.log(diff(state.initialSessionForComparison,state.sessionInformation))
    // return

    let sessionInformation = _.cloneDeep(state.sessionInformation)
    delete sessionInformation.affiliates
    delete sessionInformation.availableInstructors
    delete sessionInformation.approvals
    delete sessionInformation.courses    

    // Proof of each address the grid already verified, so the save does not
    // pay Google to check it again.
    const checkFor = rootGetters['addressVerification/checkFor']
    sessionInformation.sessions.forEach(session => {
        session.students.forEach(student => {
            const check = checkFor(pickAddress(student))
            student.addressVerificationToken = check && check.status === 'verified' ? check.token : null
        })
    })

    return api.post(`/calendar/${endpoint}`, sessionInformation)
}

async function removeSession({ commit, state }, payload) {
    const sessionCount = state.sessionInformation.sessions.length
    if (sessionCount == 1) {
        notify.create({ message: "Can't delete only session. Please add another session first and try again.", type: "negative" })
    }
    let session = state.sessionInformation.sessions[payload]
    
    
    // This is a db saved session
    if(session.sessionId){
        try {
            const { data: response } = await api.post('/classes/removeSession', { payload: session.sessionId })
            const { success } = response
            if (!success) throw response

            finalize()
            return response
        } catch (response) {
            notify.respond(response)
        }
    }
    // This is a local session that hasnt been saved.
    else{
        finalize()
    }

    function finalize(){
        // Select previous session
        state.sessionInformation.selected = "Session " + payload
        let newSessionList = state.sessionInformation.sessions.filter((s,i) => i != payload)
        Vue.set(state.sessionInformation, 'sessions', _.cloneDeep(newSessionList))
        
        state.sessionInformation.sessions = _.map( newSessionList, (session, i) => {
            let newLabel = `Session ${i+1}`
            session.label = newLabel
            session.value = newLabel
            return session
        })
        
        notify.create({message:'Session Deleted.', type: "positive"})
    }
}

async function destroyClass({commit, state}, payload){
    let vm = this._vm
    return await api.post('/calendar/destroy',{CLASS_ID: payload})
        .then( res => {
            let { success, message } = res.data
            notify.create({message: message, type: success ? "positive":"negative"})
            if(success){
                commit('updateAddEditClassOpenState', false)
                setTimeout(function(){
                    vm.$root.$emit('refreshGrid:classListGrid')
                    vm.$root.$emit('schedulerRefresh')
                },2000)
            }
        })
}

async function submitClassForApproval({ commit, state }, payload) {
    let vm = this._vm

    // if submitting or re-submitting, don't let them unless all students
    // have a completion date
    if (
      // 1=submit, 5=re-submit
      (payload.status == 1 || payload.status == 5)
      && !allStudentsHaveCompletedDate(state)
    ) {
      notify.create({
        message: "All students must have completion dates before the class can be processed",
        type: "negative"
      })
      return
    }

    vm.$root.$emit('refreshGrid:classApprovalsGrid')
    return api.post(`/approvals/submitClass`, payload)
}

function allStudentsHaveCompletedDate(state) {
  return _.every(state.sessionInformation.sessions, (session, i) => {
    if (session.students.length > 0) {
      if ((!session.syncStudents && i !== 0) || i === 0) {
        return _.every(session.students, student =>
          student.completedDate !== null
          && new Date(student.completedDate).toString() !== 'Invalid Date'
        )
      }
    }

    return true
  })
}

async function checkoutClass({ commit, state, rootState }, vm) {
    // Count the students from all sessions, add them to the post object based on their sync_students
    let studentIds = []
    _.map(state.sessionInformation.sessions, (session, i) => {
        if (session.students.length > 0) {
            if ((!session.syncStudents && i !== 0) || i === 0) {
                _.map(session.students, student => {
                    studentIds.push(student.studentId)
                })
            }
        }
    })

    if (!allStudentsHaveCompletedDate(state)) {
      notify.create({
        message: "All students must have completion dates before the class can be processed",
        type: "negative"
      })
      return
    }


    // If we have students, lets open the modal, add Certificate items for each student to the order
    if (studentIds.length) {
        let currentCourse = _.find(state.sessionInformation.courses, { value: state.sessionInformation.selectedCourse })
        let currentAffiliate = state.sessionInformation.selectedAffiliateObject
        
        commit('orders/setLoadOrderTypes', false, {root:true})
        // If payments are enabled, we need to process that.
        if(!currentCourse.DISABLE_PAYMENTS){
            rootState.orders.pendingPayment.canAdd = false
            let itemIndex = 0
            let orderTypeId = 0
            commit('orders/setOrderTypes', [
                {
                    "ORDER_TYPE_ID":0,
                    "ORDER_TYPE_NAME":"Certificate",
                    "USER_ID":2,
                    "PRICE": currentAffiliate.item.STUDENT_PROCESSING_FEE,
                    "MIN_AMOUNT":null,"MAX_AMOUNT":null,"LK_USER_TYPE_ID":null,
                    "DATE_CREATED":"2018-08-30T20:15:50.000Z","DATE_UPDATED":"2018-08-30T20:15:50.000Z","DATE_DELETED":null,
                    "DELETABLE_IND":0,
                    "SHIPPING_METHODS":[]
                }
            ], { root: true })
            
            commit('setProcessing', true)
            rootState.orders.processPaymentModalOpen = true
            commit('orders/addPendingOrderItem', {}, { root: true })
            commit('orders/updateItemFromType', {
                itemIndex: itemIndex,
                quantity: studentIds.length,
                orderType: orderTypeId // orderType.ORDER_ID
            }, { root: true })

            commit('orders/updatePaymentCallback', issueCertificates, {root:true})            
        }
        else{
            issueCertificates({data:{success:true, data:{ ORDER_ID: null }}})
        }

        async function issueCertificates (orderData) {
            try{
                if(orderData && !orderData.data.success){
                    commit('orders/updatePaymentCallback', issueCertificates, {root:true})
                    return
                }

                let orderId = orderData ? orderData.data.data.ORDER_ID : null
                state.sessionInformation.loading = true
                state.issuing = true

                let { data } = await api.post('/certificates/issue', { orderId, studentIds, classId: state.sessionInformation.classId })
                let { success, message } = data
                
                if(success){
                    setTimeout(function(){
                        // Close modal. 
                        state.classesModalState = false
                        state.sessionInformation.loading = false
                        state.issuing = false

                        vm.$root.$emit('refreshGrid:classListGrid')
                    }, 500)
                }
                else{
                    state.sessionInformation.loading = false
                    state.issuing = false
                }
                notify.create({ message: message, type: success ? 'positive' : 'negative' })
                commit('setProcessing', false)
                vm.$root.$emit('refreshApprovals')
            }
            catch(err){
                console.log(err)
                commit('setProcessing', false)
                notify.create({message:"Error issuing Certificates.", type:"negative"})
            }
        }
    }
    else {
        notify.create({ message: "No Students To Process!..", type: "negative" })
    }
}

async function loadAffiliates({ commit, state }, currentAffiliate) {
    try {
        const response = await api.post('/affiliate/classAffiliateDropdown', { currentAffiliate })
        state.sessionInformation.affiliates = response.data
    }
    catch (err) {
        console.log(err)
    }
}

async function loadAffiliatesForSearch({ commit, state }) {
    try {
        const response = await api.post('/affiliate/classAffiliateDropdown')
        state.searchAffiliates = response.data
    }
    catch (err) {
    }
}


async function loadInstructorsForAffiliate({ commit, state }, affiliateId) {
    try {
        const response = await api.post('/affiliate/classAffiliateInstructorDropdown', { affiliateId })
        // Vue.set solves the reactivity problem with arrays
        // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        Vue.set(state.sessionInformation, 'availableInstructors', _.cloneDeep(response.data))
    }
    catch (err) {
        console.log(err)
    }
}

async function loadCoursesForAffiliate({ commit, state }, { affiliateId, classId }) {
    try {
        const response = await api.post('/affiliate/classAffiliateCourseDropdown', { affiliateId, classId })
        // Vue.set solves the reactivity problem with arrays
        // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        Vue.set(state.sessionInformation, 'courses', _.cloneDeep(response.data))
    }
    catch (err) {
        console.log(err)
    }
}

async function setSessionStudentAddress({commit, state }, {}){
    commit('setSessionStudentInformation', { sessionIndex, studentIndex, type: '', value: val})
}

async function generateCertificates ({ commit, state }, certificates) {
  commit('isLoadingCertificates')
  console.log('certs', certificates)
  try {
    const certificateIds = certificates.map(certificate => certificate.CERTIFICATE_ID)
    console.log('certids', certificateIds)
    const data = await api.post('/certificates/generateCertificates', certificateIds, { responseType: 'blob' })
    commit('doneLoadingCertificates')
    return data
  } catch (response) {
    commit('doneLoadingCertificates')
    return response
  }
}

function diff(obj1,obj2,exclude) {
    var r = {};

if (!exclude)   exclude = [];

for (var prop in obj1) {
  if (obj1.hasOwnProperty(prop) && prop != '__proto__') {
        if (exclude.indexOf(obj1[prop]) == -1) {

        // check if obj2 has prop
        if (!obj2.hasOwnProperty(prop)) r[prop] = obj1[prop];

        // check if prop is object and 
        // NOT a JavaScript engine object (i.e. __proto__), if so, recursive diff
        else if (obj1[prop] === Object(obj1[prop])) {
          var difference = diff(obj1[prop], obj2[prop]);
          if (Object.keys(difference).length > 0) r[prop] = difference;
        }

        // check if obj1 and obj2 are equal
        else if (obj1[prop] !== obj2[prop]) {
            if (obj1[prop] === undefined)
            r[prop] = 'undefined';
            if (obj1[prop] === null)
            r[prop] = null;
          else if (typeof obj1[prop] === 'function')
            r[prop] = 'function';
          else if (typeof obj1[prop] === 'object')  
            r[prop] = 'object';
          else
              r[prop] = obj1[prop];
        }
      }
   }
   
}

return r;
}

async function deleteClass({ commit }, { classId }){
    try{
        const response = await api.post('classes/deleteClass', { classId })
        commit('updateAddEditClassOpenState', false)
        notify.create({
            message: "Successfully deleted class.",
            type: "positive",
        })
        return response
    }
    catch(err){
        notify.create({
            message: "Error deleting class.",
            type: "negative"
        })
        return { error: true }
    }
}
